import type {Thread} from '@github-ui/diff-lines/conversation-types'
import {fileLevelCommentKey, type FileKey, type LineKey} from '@github-ui/diff-lines/types'
import {OUTSIDE_DIFF_KEY} from '../../helpers/diff-helpers'

/**
 *
 * @param thread
 * @returns the line key and file key while taking into account whether or not the thread is unpositionable. If
 *  it is, we return OUTSIDE_DIFF_KEY
 */
export function getThreadPreviewsLineAndFileKeysFromThread(thread: Thread): {
  filePath: string
  lineKey: LineKey | FileKey
} {
  if (!thread.shouldRenderInDiffLines) {
    return {filePath: OUTSIDE_DIFF_KEY, lineKey: OUTSIDE_DIFF_KEY}
  }

  const markerEndLine = thread.positioning?.endLine !== undefined ? thread.positioning.endLine : thread.subject?.endLine
  const markerEndDiffSide = thread.positioning?.endDiffSide ?? thread.subject?.endDiffSide
  const isRightOrLeftSide = markerEndDiffSide === 'RIGHT' ? 'R' : 'L'
  // if the thread has no end line, then it is a file level comment.
  const isFileLevelComment = thread.subjectType?.toUpperCase() === 'FILE'

  const threadPath = thread.positioning?.path ?? thread.path ?? ''
  // we stitch the path into an unpositioned comment, but if it has no end line, then we know for sure that
  // it is unpositionable.
  const filePath = isFileLevelComment ? threadPath : markerEndLine && threadPath !== '' ? threadPath : OUTSIDE_DIFF_KEY
  const backupLineKey = isFileLevelComment ? fileLevelCommentKey : OUTSIDE_DIFF_KEY
  const lineKey = markerEndLine ? (`${isRightOrLeftSide}${markerEndLine}` as LineKey) : backupLineKey

  return {filePath, lineKey}
}
